import { Route, Routes } from 'react-router-dom';

import { AccessControl } from '../../components';
import { OurEntityAction, useOurEntityAuthz } from '../../hooks/useOurEntityAuthz';
import { Loader } from '../conversationWidget/components/Loader';

import OurEntityDetails from './ourentity/OurEntityDetail';
import OurEntityList from './ourentity/OurEntityList';
import OurEntityForm from './OurEntityForm';

export const OurEntityRoute = () => {
  const isAuthorizedViewOurEntityList = useOurEntityAuthz(OurEntityAction.VIEW_ENTITY_LISTING_PAGE);
  const isAuthorizedAddOurEntity = useOurEntityAuthz(OurEntityAction.ADD_ENTITY_DETAILS);
  const isAuthorizedEditOurEntity = useOurEntityAuthz(OurEntityAction.EDIT_ENTITY_DETAILS);

  return (
    <Routes>
      <Route
        path="/create"
        element={
          isAuthorizedAddOurEntity == undefined ? (
            <Loader />
          ) : isAuthorizedAddOurEntity ? (
            <OurEntityForm />
          ) : (
            <AccessControl />
          )
        }
      />
      <Route
        path="/list"
        element={
          isAuthorizedViewOurEntityList == undefined ? (
            <Loader />
          ) : isAuthorizedViewOurEntityList ? (
            <OurEntityList />
          ) : (
            <AccessControl />
          )
        }
      />
      <Route path=":ourEntityId/details" element={<OurEntityDetails />} />
      <Route
        path=":ourEntityId/edit"
        element={
          isAuthorizedEditOurEntity == undefined ? (
            <Loader />
          ) : isAuthorizedEditOurEntity ? (
            <OurEntityForm />
          ) : (
            <AccessControl />
          )
        }
      />
    </Routes>
  );
};
